'use client';

import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface MswProviderProps {
    children: ReactNode;
}

export function MswProvider({ children }: MswProviderProps) {
    const [isMockingReady, setIsMockingReady] = useState(process.env.NEXT_PUBLIC_API_MOCKING !== 'true');

    useEffect(() => {
        if (process.env.NEXT_PUBLIC_API_MOCKING === 'true') {
            if (process.env.NEXT_RUNTIME !== 'nodejs') {
                import('@/mocks/worker').then(({ worker }) => {
                    worker
                        .start({
                            onUnhandledRequest: 'bypass',
                        })
                        .then(() => {
                            setIsMockingReady(true);
                        });
                });
            }
        }
    }, []);

    if (!isMockingReady) {
        return null;
    }

    return children;
}
